export interface TipoObra {
  moduleID: number;
  module: string;
}

export const DEFAULT_TIPOS_OBRA: TipoObra[] = [
    { moduleID: 234, module: 'Imobili\u00E1rio' },
    { moduleID: 6, module: 'Edifica\u00E7\u00F5es' },
    { moduleID: 5, module: 'Industrial' },
    { moduleID: 7, module: 'Infraestrutura' },
];
